module.exports = " <div class=loader transition=loader _v-0fc6258c=\"\"> <div class=animation _v-0fc6258c=\"\"> <sprite :images=images :playing=!loaded _v-0fc6258c=\"\"></sprite> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0fc6258c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 747
// module chunks = 2